import { AppStateType } from "./redux-store";
//import { createSelector } from "reselect";

/*export const getUsersSelector = (state) => {
  return getUsers().filter((u) => true);
};

export const getUsersSuperSelector = createSelector(getUsers, (users) => {
  users.filter((u) => true);
});*/

export const getUsers = (state: AppStateType) => {
  return state.usersPage.users;
};

export const getPageSize = (state: AppStateType) => {
  return state.usersPage.pageSize;
};

export const getTotalUsersCount = (state: AppStateType) => {
  return state.usersPage.totalUsersCount;
};

export const getCurrentPage = (state: AppStateType) => {
  return state.usersPage.currentPage;
};

export const getIsFetching = (state: AppStateType) => {
  return state.usersPage.isFetching;
};

export const getFollowingInProgress = (state: AppStateType) => {
  return state.usersPage.followingInProgress;
};
